"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyListCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const design_system_1 = require("@hashintel/design-system");
const material_1 = require("@mui/material");
const EmptyListCard = ({ onClick, icon, headline, description, subDescription, }) => ((0, jsx_runtime_1.jsx)(design_system_1.WhiteCard, { onClick: onClick, actionSx: (theme) => ({
        "&:hover": onClick
            ? {
                [`.EmptyListCard-icon, .${material_1.typographyClasses.body1}`]: {
                    color: theme.palette.blue[70],
                },
            }
            : {},
    }), children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", sx: {
            px: 5,
            py: 4,
        }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    fontSize: 20,
                    [`.${design_system_1.fontAwesomeIconClasses.toString()}`]: { fontSize: "inherit" },
                }, className: "EmptyListCard-icon", children: icon }), (0, jsx_runtime_1.jsxs)(material_1.Box, { ml: 5, children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, { sx: { display: "flex", alignItems: "center", mb: 0.75 }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { component: "span", mr: 1, fontWeight: 500, children: headline }), onClick ? (0, jsx_runtime_1.jsx)(design_system_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faPlus }) : null] }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "microText", component: "p", sx: (theme) => ({ color: theme.palette.gray[90] }), children: description }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "microText", component: "p", sx: (theme) => ({ color: theme.palette.gray[60] }), children: subDescription })] })] }) }));
exports.EmptyListCard = EmptyListCard;
